import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import AddWorkAreaModal from 'modules/locations/components/AddWorkArea'

const AddWorkAreaModalPage = () => {
  const { navigation } = useNavigation()
  const { id } = useStrictParams<'id'>()
  const navigate = useNavigate()

  const onClose = () => {
    navigate(navigation.settings.locations.locationsId.workAreas.fullPath({ id }))
  }

  return <AddWorkAreaModal locationId={+id} onClose={onClose} />
}

export default AddWorkAreaModalPage
